// Framework and third-party non-ui
import React, { Component } from "react";

// Redux operations and local helpers/utils/modules
import Context from "../../../context/Context";
import FieldNames from "../../../aiim/datasets/FieldNames";
import QueryCriteria from "../../base/QueryCriteria";
import Topic from "../../../context/Topic";
import * as aiimUtil from "../../../aiim/util/aiimUtil";
import * as component from "../../../components/util/component";
import * as officePlanUtil from "../../base/officePlanUtil";

// Component specific modules (Component-styled, etc.)
import { FooterContainer } from "../../styles/Assets/assetStyles";
import { Panel } from "../../styles/Common/panel";
import {
  ListItem,
  ListItemTitle,
  ListItemSubtitle,
  ListItemAttribute,
  ListItemOverlay,
  ListItemOverlayContent,
  ListItemOverlayHeader,
  ListItemButtons,
} from "../../styles/Common/list";

// App components
import Items from "../common/Items";
import OfficePlan from "../../base/OfficePlan";
import Popup from "../common/Popup/Popup";
import UnitsAssignTo from "../common/UnitsAssignTo";
import ListHeader from "../common/ListHeader";
import ListCount from "../common/ListCount";

// Third-party components (buttons, icons, etc.)

// JSON

// CSS

export default class UnitsPanel extends Component {
  constructor(props) {
    super(props);
    const source = officePlanUtil.getUnitsSource();
    const unitField = Context.instance.aiim.getUnitName();
    
    let asnFieldName = FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE;
    if (source && source.layer2D) {
      const fields = source.layer2D.fields;
      let f = aiimUtil.findField(fields, asnFieldName);
      if (f) asnFieldName = f.name;
    }
    const queryCriteriaKey = this.getPanelKey();
    const queryCriteria = QueryCriteria.get(
      queryCriteriaKey,
      this.getSourceKey()
    );
    if (!queryCriteria.sortOptions) {
      queryCriteria.primarySortField = unitField;
      queryCriteria.sortOptions = {
        sortBy: queryCriteria.primarySortField,
        sortDir: "asc",
      };
    }

    const wh = `${asnFieldName} <> 'not assignable' OR ${asnFieldName} IS NULL`;
    queryCriteria.requiredExpression = wh;
    queryCriteria.where = queryCriteria.makeWhere(queryCriteria.getSource());

    this.state = component.newState({});
  }

  componentDidMount() {
    component.own(this,[
      Topic.subscribe(Topic.RefreshUnitName,(params) => {
        component.refresh(this);
      })
    ]);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
  }

  getPanelKey = () => {
    return this.props.panelKey;
  };

  getSourceKey = () => {
    return this.props.sourceKey;
  };

  getRdxFeatureItemsKey = () => {
    const queryCriteriaKey = this.getPanelKey() || "";
    return queryCriteriaKey + "_FeatureItems";
  };

  render() {
    const { layerCaption, filterTooltip } = this.props;
    const i18n = Context.instance.i18n;
    const queryCriteriaKey = this.getPanelKey() || "";

    return (
      <Panel>
        <ListHeader
          title={i18n.spaceplanner.assets.units.title}
          layerCaption={layerCaption}
          filterTooltip={filterTooltip}
          queryCriteriaKey={queryCriteriaKey}
        ></ListHeader>
        <Items
          queryCriteriaKey={queryCriteriaKey}
          rdxFeatureItemsKey={this.getRdxFeatureItemsKey()}
          renderItem={this.renderItem}
          requeryOnPlanActions={[OfficePlan.Action_AssignmentsUpdated]}
          isShowAllButton={true}
        />
        <FooterContainer>
          <ListCount
            queryCriteriaKey={queryCriteriaKey}
            label={i18n.spaceplanner.assets.units.countPattern}
          ></ListCount>

          <UnitsAssignTo
            disableUnassign={false}
            placement="bottom"
            rdxFeatureItemsKey={this.getRdxFeatureItemsKey()}
          />
        </FooterContainer>
      </Panel>
    );
  }

  renderItem = (source, featureItem, index) => {
    const i18n = Context.instance.i18n;
    const unitField = Context.instance.aiim.getUnitName();
    const key = featureItem.key;
    const attributes = featureItem.feature.attributes;
    const name = aiimUtil.getAttributeValue(attributes, unitField);
    const asnName = officePlanUtil.getUnitAssignmentName(featureItem);
    const labelWithNameString = i18n.spaceplanner.units.assignTo.labelWithName;
    const labelWithName = labelWithNameString.replace("{name}", name);
    const isUnassigned = officePlanUtil.isUnitUnassigned(featureItem);

    let siteName, facilityName, levelNumber;
    const zInfo = Context.instance.aiim.getZInfo(source,featureItem.feature);
    const levelData = zInfo && zInfo.levelData
    if (levelData) {
      siteName = levelData.siteName;
      facilityName = levelData.facilityName;
      levelNumber = levelData.levelNumber;
      if (!siteName) siteName = aiimUtil.getAttributeValue(attributes,FieldNames.SITE_NAME);
      //console.log("siteName",siteName,"facilityName",facilityName,"levelNumber",levelNumber)
    } else {
      siteName = aiimUtil.getAttributeValue(attributes,FieldNames.SITE_NAME);
      facilityName = aiimUtil.getAttributeValue(attributes,FieldNames.FACILITY_NAME);
      levelNumber = aiimUtil.getAttributeValue(attributes,FieldNames.LEVEL_NUMBER);
    }

    let facilityLevel = null;
    if (facilityName && typeof levelNumber === "number") {
      const pattern = i18n.spaceplanner.units.facilityFloorPattern;
      facilityLevel = pattern.replace("{facility}", facilityName);
      facilityLevel = facilityLevel.replace("{level}", levelNumber);
    } else {
      facilityLevel = facilityName || levelNumber || null;
    }

    const clicked = (event) => {
      Topic.publish(Topic.ShowItemPopup, {
        title: name,
        source: source,
        featureItem: featureItem,
        fetchFeatureItemGeometry: true,
        zoom: true,
        content: (
          <Popup
            sourceKey={this.getSourceKey()}
            featureItem={featureItem}
          />
        ),
      });
    };

    return (
      <ListItem unassigned={isUnassigned} key={key} onClick={clicked}>
        <ListItemTitle>{name}</ListItemTitle>
        <ListItemSubtitle>
          <ListItemAttribute>{siteName || null}</ListItemAttribute>
          <ListItemAttribute>{facilityLevel}</ListItemAttribute>
          <ListItemAttribute>{asnName}</ListItemAttribute>
        </ListItemSubtitle>
        <ListItemOverlay>
          <ListItemOverlayContent>
            <ListItemOverlayHeader>{labelWithName}</ListItemOverlayHeader>
            <ListItemButtons>
              <UnitsAssignTo
                featureItems={[featureItem]}
                rdxFeatureItemsKey={this.getRdxFeatureItemsKey()}
                disableUnassign={isUnassigned}
                enableUnassign={!isUnassigned}
                name={name}
                buttons
              />
            </ListItemButtons>
          </ListItemOverlayContent>
        </ListItemOverlay>
      </ListItem>
    );
  };
}
